import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0052B4",
  d: "M16.517 9.392h-3.012l-1.506-2.609-1.506 2.61H7.48L8.987 12 7.48 14.61h3.013l1.506 2.608 1.506-2.608h3.012L15.011 12zm-2.668 2.609-.925 1.602h-1.85l-.925-1.602.925-1.603h1.85zM12 8.796l.344.596h-.688zm-2.776 1.602h.689l-.344.597zm0 3.205.345-.596.344.596zM12 15.206l-.344-.596h.688zm2.776-1.603h-.69l.345-.596zm-.69-3.205h.69l-.345.597zM19.47 2.61H4.53a12 12 0 0 0-2.768 3.13h20.477a12 12 0 0 0-2.769-3.13M4.53 21.391h14.94a12 12 0 0 0 2.77-3.13H1.761a12 12 0 0 0 2.769 3.13"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }